import React from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';

const ClientLogos = () => {
  const clients = [
  {
    name: "W.L. Gore & Associates",
    logo: "/assets/images/W._L._Gore_Associates_logo.svg-1769847752535.png",
    logoAlt: "W.L. Gore and Associates logo featuring red corporate branding with professional typography"
  },
  {
    name: "Stryker Corporation",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_16fac4f47-1769569731835.png",
    logoAlt: "Stryker Corporation logo featuring bold red and white corporate branding on clean white background"
  },
  {
    name: "AposHealth",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1a14fbdb6-1769848386211.png",
    logoAlt: "AposHealth company logo displaying modern healthcare technology branding"
  },
  {
    name: "Sight Sciences",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1dc43404c-1769848390491.png",
    logoAlt: "Sight Sciences logo featuring professional medical device company branding"
  },
  {
    name: "Saluda Medical",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1bee0de0b-1769848388767.png",
    logoAlt: "Saluda Medical logo displaying innovative medical technology branding"
  },
  {
    name: "Nevro",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1f0d6996e-1769848387386.png",
    logoAlt: "Nevro company logo featuring modern neuromodulation technology branding"
  },
  {
    name: "Noctrix Health",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_143410205-1769848386189.png",
    logoAlt: "Noctrix Health logo displaying healthcare innovation branding"
  },
  {
    name: "Spineology",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_18d1de609-1769848386038.png",
    logoAlt: "Spineology company logo featuring spinal medical device branding"
  },
  {
    name: "Curonix",
    logo: "/assets/images/logo_curonix-nav-color-1769848312750.png",
    logoAlt: "Curonix logo displaying advanced medical device technology branding"
  }];


  // Duplicate the clients array for seamless infinite scroll
  const duplicatedClients = [...clients, ...clients];

  return (
    <section className="bg-white py-12 md:py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <p className="text-sm md:text-base text-gray-600 font-medium mb-2 md:mb-3">TRUSTED BY HEALTHCARE LEADERS</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1B1B20]">
            Provider Groups, Specialty Practices, and Manufacturers Rely on PolicyAlerts
          </h2>
        </div>

        {/* Carousel Container */}
        <div className="relative overflow-hidden mb-10 md:mb-12 lg:mb-16">
          <motion.div
            className="flex gap-6 md:gap-8 lg:gap-10"
            animate={{
              x: [0, -100 * clients?.length / 2 + '%']
            }}
            transition={{
              x: {
                repeat: Infinity,
                repeatType: "loop",
                duration: 30,
                ease: "linear"
              }
            }}>

            {duplicatedClients?.map((client, idx) =>
            <div
              key={idx}
              className="flex-shrink-0 w-40 md:w-48 lg:w-56 flex items-center justify-center p-4 md:p-6 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors group">

                <Image
                src={client?.logo}
                alt={client?.logoAlt}
                className="w-full h-12 md:h-14 lg:h-16 object-contain grayscale group-hover:grayscale-0 transition-all opacity-60 group-hover:opacity-100" />

              </div>
            )}
          </motion.div>
        </div>

        <div className="mt-10 md:mt-12 lg:mt-16">
          <div className="bg-gradient-to-br from-[#1B1B20] to-[#2A2A30] rounded-2xl p-5 md:p-6 lg:p-8 text-white">
            <div className="flex items-center justify-between mb-5">
              <div>
                <h3 className="text-lg md:text-xl font-bold mb-2">Live Policy Activity Feed</h3>
                <p className="text-xs md:text-sm text-gray-400">Real-time monitoring across all major payers</p>
              </div>
              <div className="flex items-center gap-2 bg-green-500/20 px-3 py-1.5 rounded-full border border-green-500/30">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span className="text-xs font-medium text-green-400">Live</span>
              </div>
            </div>

            <div className="space-y-2.5">
              {[
              {
                payer: "UnitedHealthcare",
                change: "Coverage criteria updated for CPT 64555",
                type: "Medical Policy",
                impact: "High",
                time: "2 min ago",
                impactColor: "#ED1C24"
              },
              {
                payer: "Aetna",
                change: "Prior authorization requirements modified",
                type: "Administrative",
                impact: "Medium",
                time: "8 min ago",
                impactColor: "#F59E0B"
              },
              {
                payer: "Medicare Part B",
                change: "LCD revision for spinal procedures",
                type: "Local Coverage",
                impact: "High",
                time: "15 min ago",
                impactColor: "#ED1C24"
              },
              {
                payer: "Cigna",
                change: "Reimbursement rate adjustment for J-codes",
                type: "Billing Policy",
                impact: "Medium",
                time: "23 min ago",
                impactColor: "#F59E0B"
              },
              {
                payer: "Blue Cross Blue Shield",
                change: "New coverage policy for orthopedic devices",
                type: "Medical Policy",
                impact: "High",
                time: "31 min ago",
                impactColor: "#ED1C24"
              }]?.
              map((activity, idx) =>
              <div
                key={idx}
                className="bg-white/5 backdrop-blur-sm rounded-xl p-3.5 md:p-4 border border-white/10 hover:border-[#1A73E8]/50 transition-all group cursor-pointer">

                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-2.5">
                    <div className="flex-1">
                      <div className="flex items-center gap-2.5 mb-1.5">
                        <span className="text-xs md:text-sm font-semibold text-white">{activity?.payer}</span>
                        <span className="text-xs px-2 py-0.5 bg-[#1A73E8]/20 text-[#1A73E8] rounded-full border border-[#1A73E8]/30">
                          {activity?.type}
                        </span>
                      </div>
                      <p className="text-xs md:text-sm text-gray-300 group-hover:text-white transition-colors">
                        {activity?.change}
                      </p>
                    </div>
                    <div className="flex items-center gap-3 flex-shrink-0">
                      <div className="flex items-center gap-1.5">
                        <div
                        className="w-2 h-2 rounded-full"
                        style={{ backgroundColor: activity?.impactColor }}>
                      </div>
                        <span className="text-xs text-gray-400">{activity?.impact} Impact</span>
                      </div>
                      <span className="text-xs text-gray-500">{activity?.time}</span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="mt-5 pt-5 border-t border-white/10">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                <div className="text-center">
                  <p className="text-2xl md:text-3xl font-bold text-[#1A73E8] mb-1">127</p>
                  <p className="text-xs md:text-sm text-gray-400">Changes Today</p>
                </div>
                <div className="text-center">
                  <p className="text-2xl md:text-3xl font-bold text-[#10B981] mb-1">1,843</p>
                  <p className="text-xs md:text-sm text-gray-400">This Week</p>
                </div>
                <div className="text-center">
                  <p className="text-2xl md:text-3xl font-bold text-[#F59E0B] mb-1">38</p>
                  <p className="text-xs md:text-sm text-gray-400">High Impact</p>
                </div>
                <div className="text-center">
                  <p className="text-2xl md:text-3xl font-bold text-[#ED1C24] mb-1">100K+</p>
                  <p className="text-xs md:text-sm text-gray-400">Policies Tracked</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);


};

export default ClientLogos;